module.exports = __webpack_public_path__ + "img/cerrar__btn.50305688.svg";